/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents a kind of event in the bell.
 */
export enum OrgEventKind {
  FORM_FILLED = "form_filled",
  PAYMENT_METHOD_ADDED = "payment_method_added",
  CHARGE_FAILED = "charge_failed",
  TUTOR_BANK_ADDED = "tutor_bank_added",
  MEETING_REQUESTED = "meeting_requested",
  MEETING_REQUEST_ANSWERED = "meeting_request_answered",
  MEETING_BOOKED = "meeting_booked",
}
